import clsx from "clsx";
import { forwardRef, ImgHTMLAttributes } from "react";
import classes from "./image.module.css";

export type ImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  alt: string;
};

export const Image = forwardRef<HTMLImageElement, ImageProps>(
  ({ loading = "lazy", alt, sizes = "auto", className, ...props }, ref) => {
    return (
      <img
        ref={ref}
        className={clsx(classes.root, className)}
        loading={loading}
        sizes={sizes}
        alt={alt}
        {...props}
      />
    );
  },
);

Image.displayName = "Image";
